var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "25px",
    viewBox: "13 16 31 25",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4791911,19 C13.6622564,19 13,18.3284271 13,17.5 C13,16.6715729 13.6622564,16 14.4791911,16 L42.5208089,16 C43.3377436,16 44,16.6715729 44,17.5 C44,18.3284271 43.3377436,19 42.5208089,19 L14.4791911,19 Z M14.4791911,30 C13.6622564,30 13,29.3284271 13,28.5 C13,27.6715729 13.6622564,27 14.4791911,27 L42.5208089,27 C43.3377436,27 44,27.6715729 44,28.5 C44,29.3284271 43.3377436,30 42.5208089,30 L14.4791911,30 Z M14.4791911,41 C13.6622564,41 13,40.3284271 13,39.5 C13,38.6715729 13.6622564,38 14.4791911,38 L42.5208089,38 C43.3377436,38 44,38.6715729 44,39.5 C44,40.3284271 43.3377436,41 42.5208089,41 L14.4791911,41 Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.78f4307a.svg";
export { ForwardRef as ReactComponent };